import AddFamilyExternal from '@/pages/AddFamilyExternal/index';
import WelcomeInfo from '@/pages/AddFamilyExternal/views/WelcomeInfo';
import FamilyReporterExternal from '@/pages/AddFamilyExternal/views/FamilyReporterExternal';
import FamilyDetails from '@/pages/AddFamilyExternal/views/FamilyDetails';
import FamilyConsent from '@/pages/AddFamilyExternal/views/FamilyConsent';
import FamilyInformation from '@/pages/AddFamilyExternal/views/FamilyInformation';
import FamilySummary from '@/pages/AddFamilyExternal/views/FamilySummary';

export default {
    path: '/zglaszam',
    component: AddFamilyExternal,
    children: [
        {
            path: '',
            name: 'add-family-external',
            redirect: { name: 'family-welcome-info' }
        },
        {
            path: 'witaj',
            name: 'family-welcome-info',
            component: WelcomeInfo
        },
        {
            path: 'twoje-dane',
            name: 'family-reporter-external',
            component: FamilyReporterExternal
        },
        {
            path: 'zgoda',
            name: 'family-consent-external',
            component: FamilyConsent
        },
        {
            path: 'dane',
            name: 'family-details-external',
            component: FamilyDetails
        },
        {
            path: 'informacja',
            name: 'family-information-external',
            component: FamilyInformation
        },
        {
            path: 'dziekujemy',
            name: 'family-summary-external',
            component: FamilySummary
        }
    ]
};
